import Vue from 'vue';

// * alertbox mixin import and use
import alertbox_mixin from '@/modules/alertbox/alertbox_mixin.js';
Vue.use(alertbox_mixin);

// * alertbox component import and register
import alertbox_component from '@/modules/alertbox/alertbox_component.vue';
Vue.component('alertbox', alertbox_component);
